import React from "react";
import { Menu } from "antd";
import { Link } from "react-router-dom";
import {
  HomeOutlined,
  ProfileOutlined,
  PhoneOutlined,
  DownloadOutlined,
  ExceptionOutlined,
} from "@ant-design/icons";

const PublicView = (props) => {
  return (
    <Menu theme="dark" selectedKeys={[props.selectedKey]} mode="inline">
      <Menu.Item key="1" className="sidebar-focusable">
        <Link style={{ textDecoration: "none" }} to="/">
          <HomeOutlined />
          <span> POČETNA STRANICA </span>
        </Link>
      </Menu.Item>
      <Menu.Item key="2" className="sidebar-focusable">
        <Link style={{ textDecoration: "none" }} to="/pregled-registara">
          <ProfileOutlined />
          <span> PREGLED REGISTARA</span>
        </Link>
      </Menu.Item>
      <Menu.Item key="10" className="sidebar-focusable">
        <Link style={{ textDecoration: "none" }} to="/kontakt">
          <PhoneOutlined />
          <span> KONTAKT</span>
        </Link>
      </Menu.Item>

      <Menu.Item key="11" className="sidebar-focusable">
        <Link style={{ textDecoration: "none" }} onClick={props.downloadUputa} to="#">
          <DownloadOutlined />
          <span> {" KORISNIČKA UPUTA"}</span>
        </Link>
      </Menu.Item>
    </Menu>
  );
};

export default PublicView;
